import Game from './scenes/Game';
import Intro from './scenes/Intro';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [Intro, Game],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: Intro.KEY,

  // startScene: Game.KEY,

  CURRENT_LEVEL: 1,
  mode: 'halloween' // set via the ABCyaConfig, defaults to halloween; possible values: halloween, easter, christmas, hanukkah, shamrock, valentines
};

// template switch statement for game mode
// switch (gameData.mode) {
//   case 'halloween':
//     break;
//   case 'christmas':
//     break;
//   case 'easter':
//     break;
//   case 'hanukkah':
//     break;
//   case 'shamrock':
//     break;
//   case 'valentines':
//     break;
// }